import React from "react";
import "../assets/styles/main.scss";

type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
};

const Button: React.FC<ButtonProps> = ({
  children,
  className,
  onClick,
  type = "button",
  disabled,
}) => (
  <button
    className={`button ${className}`}
    onClick={onClick}
    type={type}
    disabled={disabled}
  >
    {children}
  </button>
);

export default Button;
